<template>
  <div class="header-banner">
    <div class="component-content">
      <div class="headerbanner__img">
        <picture>
          <source media="(min-width:767px)" :srcset="srcset[1024]">
          <img :src="srcset[0]" alt="Flowers">
        </picture>
      </div>
      <div class="headerbanner__content" :style="{ '--header-banner-blur-image': `url('${srcset[0]}')` }"
        :class="[!smallScreen ? horizontalPosition : '', textPosition, textColor]">
        <div v-if="title" class="banner__title">
          <component :is="htag" class="heading" v-if="title" v-html="title"></component>
        </div>
        <div v-if="descripion" class="banner__text">
          <p v-html="descripion"></p>
        </div>
        <a v-if="enableRoutineFinder === 'false' && linkText && enableDsfService === 'false' && link" :href="link"
          class="btn__wrapper" :class="ctaClass" @click="ctaTaggingPush">
          <span>{{ linkText }}</span>
        </a>

        <!--routine-banner-->
        <button v-if="enableRoutineFinder === 'true' && linkText" @click="enableRb()" class="cta cta--light btn__wrapper"> <span>{{ linkText }}</span> </button>
        <!--routine-banner-->
        <!--DSF-banner-->
         <a v-if="!smallScreen && enableDsfService === 'true' && linkText && enableRoutineFinder === 'false' && link" :href="link"
          class="btn__wrapper" :class="ctaClass" @click="ctaTaggingPush">
          <span>{{ linkText }}</span>
        </a>
        <spotscan-embed v-if="smallScreen && enableDsfService === 'true' && enableRoutineFinder === 'false'"
          :data-tenant="dsfData.Tenant" :data-application="dsfApplication" :data-customer="dsfData.Customer"
          :data-country="dsfData.Country" :data-environment="dsfData.Environment" :data-touchpoint="dsfData.Touchpoint"
          :data-type="dsfData.Type" :data-loadingbg="dsfData.Loadingbackgroundcolor"
          :data-loadingmsg="dsfData.Loadingmessage" csrf-token="$WEBSITE_TOKEN" :switch-ecom="dsfData.Switchecom"
          :switch-autostart="dsfData.Switchautostart" :data-cta-label="linkText" :data-pagecategory="dsfPageCategory"
          :data-cta="ctaClass" :data-dsf-tagging="dsfTagging"></spotscan-embed>
        <!--DSF-banner-->
      </div>

    </div>
    <routine-finder v-if="showFullWidth_Rb"></routine-finder>
  </div>
</template>

<script>
import SpotscanEmbed from '@Feature/SpotscanEmbed/code/Scripts/components/spotscan-embed.vue';
import routineFinder from '@Feature/RoutineFinder/code/Scripts/components/routine-finder.vue';
export default {
  name: 'header-banner',
  components: {
    SpotscanEmbed,
    routineFinder
  },
  props: {
    srcset: {
      type: [Object],
      required: true,
      default: undefined
    },
    horizontalPosition: {
      type: String,
      required: false,
      default: '--center'
    },
    textPosition: {
      type: String,
      required: false,
      default: '--textLeft'
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    link: {
      type: String,
      required: false,
      default: ''
    },
    linkText: {
      type: String,
      required: false,
      default: ''
    },
    descripion: {
      type: String,
      required: false,
      default: ''
    },
    textColor: {
      type: String,
      required: false,
      default: 'white'
    },
    htag: {
      type: String,
      required: false,
      default: 'h1'
    },
    ctaTagging: {
      type: String,
      required: false,
    },
    enableRoutineFinder: {
      type: [String | Boolean],
      default: false
    },
    ctaClass: {
      type: String,
      default: 'cta cta--light'
    },
    enableDsfService: {
      type: String,
      default: 'false'
    },
    dsfData: {
      type: Object,
      required: true
    },
    dsfApplication: {
      type: String,
      default: ''
    },
    dsfPageCategory: {
      type: String,
      default: ''
    },
    dsfTagging: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      smallScreen: window.matchMedia('(max-width: 768px)').matches,
      showFullWidth_Rb: false,
    };
  },
  mounted() { 
    this.handleRoutineFinderClose = (value) => {
  setTimeout(() => {
    this.showFullWidth_Rb = value;
  }, 300);
};
window.eventBus.$on('routineFinderClose:on', this.handleRoutineFinderClose);
  },
  methods: {
    
    enableRb() {
      this.showFullWidth_Rb = true;
    },
    ctaTaggingPush() {
      const pushTagging = JSON.parse(this.ctaTagging);
      if (pushTagging) {
        dataLayer.push(pushTagging)
      }
    },
  },
  beforeDestroy() {
  window.eventBus.$off('routineFinderClose:on', this.handleRoutineFinderClose);
  }
  
};
</script>

<style lang="scss" src="./header-banner.scss"></style>
